export const later = {
  "audiences": { change: () => import("./optional/audiences/change.tsx"), screen: () => import("./optional/audiences/screen.tsx") },
  "breakdowns": { level: () => import("./optional/breakdowns/level.tsx") },
  "brief-campaign": {
    change: () => import("./optional/brief-campaign/change.tsx"),
    brief: () => import("./optional/brief-campaign/brief.tsx"),
    request: () => import("./optional/brief-campaign/request.tsx"),
    thread: () => import("./optional/brief-campaign/thread.tsx"),
  },
  "creative-watch": { level: () => import("./optional/creative-watch/level.tsx") },
  "daily-diary": { screen: () => import("./optional/daily-diary/screen.tsx") },
  "daily-introspection": { diary: () => import("./optional/daily-introspection/diary.tsx") },
  "drive-creatives": {
    level: () => import("./optional/drive-creatives/level.tsx"),
    attach: () => import("./optional/drive-creatives/attach.tsx"),
    screen: () => import("./optional/drive-creatives/screen.tsx"),
  },
  "fresh-campaign": { change: () => import("./optional/fresh-campaign/change.tsx") },
  "google-sign-in": {
    page: () => import("./optional/google-sign-in/page.tsx"),
    entrance: () => import("./optional/google-sign-in/entrance.tsx"),
  },
  "growth-planning": { screen: () => import("./optional/growth-planning/screen.tsx") },
  "levers": { level: () => import("./optional/levers/level.tsx"), change: () => import("./optional/levers/change.tsx") },
  "manual-round": { agenda: () => import("./optional/manual-round/agenda.tsx") },
  "new-ads": {
    level: () => import("./optional/new-ads/level.tsx"),
    change: () => import("./optional/new-ads/change.tsx"),
    attach: () => import("./optional/new-ads/attach.tsx"),
  },
  "notify": { sheet: () => import("./optional/notify/sheet.tsx") },
  "owner-week": { page: () => import("./optional/owner-week/page.tsx") },
  "team-requests": { screen: () => import("./optional/team-requests/screen.tsx") },
  "video-speech": {
    attach: () => import("./optional/video-speech/attach.tsx"),
    attached: () => import("./optional/video-speech/attached.tsx"),
  },
};
